import { PreferredJobSitterDTO } from 'parent-portal/forms/components/pages/ProviderPreferencesPage/preferredWorkersApi';
import { client } from 'shared';

interface UpdateBusinessAppointmentBody {
    start_date?: string;
    end_date?: string;
    preferred_sitters?: PreferredJobSitterDTO;
}

export function updateBusinessAppointment(shiftId: number, body: UpdateBusinessAppointmentBody) {
    return client(`api/business-appointment/${shiftId}/`, {
        method: 'PATCH',
        body: body,
    });
}
